import { logEvent } from 'firebase/analytics';

import { analytics } from './config';

export const logExperimentView = (experimentId: string, variant: string) => {
  // Only log event if analytics is available
  if (analytics) {
    logEvent(analytics, 'experiment_view', {
      experiment_id: experimentId,
      variant,
    });
  }
};

export const logExperimentClick = (experimentId: string, variant: string) => {
  // Only log event if analytics is available
  if (analytics) {
    logEvent(analytics, 'experiment_click', {
      experiment_id: experimentId,
      variant,
    });
  }
};
